<div *ngIf="block && block.data && block.data.steps && block.data.steps.length > 0" class="flex flex-col">
  <div
    *ngFor="let step of block.data.steps"
    class="relative flex gap-4 after:absolute after:left-5 after:top-0 after:block after:h-full after:border after:border-pl-green-500 after:content-[''] after:last:hidden"
    [ngClass]="{
      'after:border-pl-green-500': step.status === EntityStatus.completed,
      'after:border-pl-gray-400': step.status === EntityStatus.current || step.status === EntityStatus.locked
    }"
  >
    <div class="relative h-10 w-10">
      <pl-icon
        *ngIf="step.status === EntityStatus.completed"
        [name]="PlIcon.tick"
        [frame]="IconFrame.round"
        class="absolute z-10 bg-white text-pl-green-500"
      />
      <pl-icon
        *ngIf="step.status === EntityStatus.current"
        [name]="PlIcon.eye"
        [frame]="IconFrame.round"
        class="absolute z-10 bg-white text-pl-blue-500"
      />
      <pl-icon
        *ngIf="step.status === EntityStatus.locked"
        [name]="PlIcon.lock"
        class="absolute z-10 rounded-full bg-pl-gray-400 p-3 text-white"
      />
    </div>
    <div class="pb-4">
      <p class="font-bold uppercase leading-4 text-pl-orange-800">{{ step.title }}</p>
      <p class="text-lg">{{ step.name }}</p>
      <p class="text-xs font-bold">{{ step.description }}</p>
    </div>
  </div>
</div>
